// import CategoryDataSource from "../CategoryDataSource";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import { Product } from "../../../Domain/Model/Product";
import { Products } from "../../../Domain/Model/Products";
import { ProductState } from "../../../Domain/Model/ProductState";
import ProductDataSource from "../ProductDataSource";
import { ProductGalleryAPIEntity } from "./Entity/ProductGalleryAPIEntity";
import { ProductsAPIEntity } from "./Entity/ProductsAPIEntity";

// const baseURL = `${Environment.apiUrl}/product`;
const routeName = `/v1/product`;

export default class ProductAPIDataSourceImpl implements ProductDataSource{

  async createProduct(data: Product): Promise<number> {
    try {
      // Define los datos que deseas enviar en la petición POST
      const postData = {
        categoryId: data.categoryId,
        subCategoryId: data.subCategoryId,
        brandId: data.brandId,
        colorId: data.colorId,
        productName: data.productName,
        sku: data.sku,
        model: data.model,
        youtube: data.youtube ?? "",
        stock: data.stock,
        salePrice: data.salePrice,
        discountPrice: data.discountPrice,
        bankTransferPrice: data.bankTransferPrice,
        yapePrice: data.yapePrice,
        characteristics: data.characteristics,
        details: data.details,
        description: data.description,
        status: data.status,
        isDiscount: data.isDiscount,
        isVisibleBankTransferPrice: data.isVisibleBankTransferPrice,
        isVisibleYapePrice: data.isVisibleYapePrice,
        // mainImage: data.mainImage,
        dateLimitDiscount: data.dateLimitDiscount,
      };
    
      // Realiza la petición POST utilizando axios
      const response = await api.post<ApiResponse<any>>(routeName, postData);
      
      // Verifica si la respuesta contiene datos
      if (response.data.succeeded === true && response.data?.data) {

        return response.data.data;
      } else {
        // Maneja el caso en el que la respuesta no tiene el formato esperado
        throw new Error("La respuesta no tiene el formato esperado o falta el ID del producto.");
      }
    } catch (error) {
      // Maneja errores de solicitud
      console.error("Error al agragar el producto:", error);
      throw new Error("Error al agragar el producto");
    }
  }
        
        
        // async getProducts(): Promise<ProductsAPIEntity[]> {
        //   try {
        //     const response = await axios.get(baseURL, {
        //       headers: {
        //         'Content-Type': 'application/json',
        //         'accept': '*/*'
        //       }
        //     });
        //     // console.log(response.data.data);
        //     const listProducts = response.data.data.items;
        //     // Verifica si la respuesta contiene datos
        //     if (listProducts && Array.isArray(listProducts)) {
        //       // Mapea los datos de la respuesta al formato de Category que esperas
        //       const products: Products[] = listProducts.map((item: Products) => ({
        //         productId: item.productId,
        //         productName: item.productName,
        //         sku: item.sku,
        //         salePrice: item.salePrice,
        //         discountPrice: item.discountPrice,
        //         stock: item.stock,
        //         created: item.created,
        //         status: item.status,
        //         mainImage: item.mainImage,
        //       }));
              
        //       return products;
        //     } else {
        //       // Maneja el caso en el que la respuesta no tiene el formato esperado
        //       throw new Error("La respuesta no tiene el formato esperado");
        //     }
        //   } catch (error) {
        //     // Maneja errores de solicitud
        //     console.error("Error al obtener los productos:", error);
        //     throw new Error("Error al obtener los productos");
        //   }
        // }
        async getProducts(page = 0, pageSize = 10, search: string = ''): Promise<PaginationResult<Products>> {

          const SortOrder = "desc";
          try {
            const response = await api.get<ApiResponse<any>>(routeName, {
              params: { page, pageSize, search, SortOrder }
            });
        
            const data = response.data.data;
        
            if (data && Array.isArray(data.items)) {
              const products: Products[] = data.items.map((item: Products) => ({
                productId: item.productId,
                productName: item.productName,
                sku: item.sku,
                salePrice: item.salePrice,
                discountPrice: item.discountPrice,
                stock: item.stock,
                created: item.created,
                status: item.status,
                mainImage: item.mainImage,
                url: item.url
              }));
        
              return {
                items: products,
                page: data.page,
                pageSize: data.pageSize,
                totalCount: data.totalCount,
                hasNextPage: data.hasNextPage,
                hasPreviousPage: data.hasPreviousPage,
              };
            } else {
              throw new Error("La respuesta no tiene el formato esperado");
            }
          } catch (error) {
            console.error("Error al obtener los productos:", error);
            throw new Error("Error al obtener los productos");
          }
        }
        async getProductById(productId: number): Promise<Product | null> {
          try {
              const response = await api.get<ApiResponse<any>>(`${routeName}/${productId}`);
      
              const product = response.data?.data;
      
              // Verifica si el producto existe y tiene el formato correcto
              if (product) {
                return {
                    categoryId: product.categoryId,
                    subCategoryId: product.subCategoryId,
                    brandId: product.brandId,
                    colorId: product.colorId,
                    productName: product.productName,
                    sku: product.sku,
                    model: product.model,
                    youtube: product.youtube,
                    stock: product.stock,
                    salePrice: product.salePrice,
                    discountPrice: product.discountPrice,
                    bankTransferPrice: product.bankTransferPrice,
                    yapePrice: product.yapePrice,
                    characteristics: product.characteristics,
                    details: product.details,
                    description: product.description,
                    status: product.status,
                    isDiscount: product.isDiscount,
                    isVisibleBankTransferPrice: product.isVisibleBankTransferPrice,
                    isVisibleYapePrice: product.isVisibleYapePrice,
                    // mainImage: product.mainImage,
                    dateLimitDiscount: product.dateLimitDiscount,
                    discountPercentage: product.discountPercentage
                };
            }

            return null;
          } catch (error) {
            console.error("Error al obtener los productos:", error);
            return null;
          }
        }
    
        async updateProduct(data: Product): Promise<boolean> {
          try {
            // Realiza la petición PUT utilizando axios
            const response = await api.put<ApiResponse<any>>(`${routeName}`, data);
      
            // Verifica si la respuesta contiene datos
            if (response.data.succeeded === true) {
              // Devuelve true si la actualización fue exitosa
              return true;
            } else {
              // Maneja el caso en el que la respuesta no tiene el formato esperado
              throw new Error("La respuesta no tiene el formato esperado");
            }
          } catch (error) {
            // Maneja errores de solicitud
            console.error("Error al actualizar el producto:", error);
            throw new Error("Error al actualizar el producto");
          }
        }
        async updateStateProduct(data: ProductState): Promise<boolean> {
          try {
            // Realiza la petición PUT utilizando axios
            const response = await api.post<ApiResponse<any>>(`${routeName}/update-status`, data);
      
            // Verifica si la respuesta contiene datos
            if (response.data?.succeeded) {
              // Devuelve true si la actualización fue exitosa
              return true;
            } else {
              console.warn("La API respondió con un formato inesperado:", response.data);
              return false;
            }
          } catch (error: any) {
              // Si hay error en la respuesta, intentamos obtener detalles
              if (error.response) {
                console.error(`Error ${error.response.status}:`, error.response.data);
              } else {
                console.error("Error de red o de servidor:", error.message);
              }
              return false; // Retornamos false en lugar de lanzar una excepción
          }
        }

        async updateTableProduct(data: ProductsAPIEntity): Promise<boolean> {
          try {
            // Realiza la petición PUT utilizando axios
            const response = await api.put<ApiResponse<any>>(`${routeName}/update-summary`, data);
      
            // Verifica si la respuesta contiene datos
            if (response.data?.succeeded) {
              // Devuelve true si la actualización fue exitosa
              return true;
            } else {
              console.warn("La API respondió con un formato inesperado:", response.data);
              return false;
            }
          } catch (error: any) {
              // Si hay error en la respuesta, intentamos obtener detalles
              if (error.response) {
                console.error(`Error ${error.response.status}:`, error.response.data);
              } else {
                console.error("Error de red o de servidor:", error.message);
              }
              return false; // Retornamos false en lugar de lanzar una excepción
          }
        }

        async uploadProductGallery(data: ProductGalleryAPIEntity): Promise<boolean> {
          try {
            const response = await api.post<ApiResponse<any>>(`${routeName}/upload-gallery`, data, {
               headers: {
                "Content-Type": "multipart/form-data",
              }
            });
            if (response.data.succeeded === true) {
              console.log(response);
              // Devuelve true si la actualización fue exitosa
              return true;
            } else {
              // Maneja el caso en el que la respuesta no tiene el formato esperado
              throw new Error("La respuesta no tiene el formato esperado");
            }
    
          
        } catch (error) {
          console.error("Error al subir imágenes:", error);
            throw new Error("Error al subir imágenes:");
          }
        }
        async viewProductGalleryById(productId: number):Promise<any>{
          try {
            const response = await api.get<ApiResponse<any>>(`${routeName}/${productId}/gallery`);
            const galleryData = response.data.data;
      
              // Verifica si el producto existe y tiene el formato correcto
              const gallery: [] = galleryData.map((item: any) => ({
                id: item.id,
                slug: item.slug,
              }));

              if (gallery) {
                return gallery;
            }
            
    
          
        } catch (error) {
          console.error("Error al obtener imágenes:", error);
            throw new Error("Error al obtener imágenes:");
          }

        }

        async setMainImage(data: any):Promise<string | undefined>{
          try {
            const response = await api.put<ApiResponse<any>>(`${routeName}/set-main-image`, data);
           
              if (response.data.succeeded===true) {
                return response.data.data;
            }   
        } catch (error) {
          console.error("Error al obtener imágenes:", error);
            throw new Error("Error al obtener imágenes:");
          }

        }

        async viewMainImage(productId: number):Promise<string | undefined>{
          try {
              const response = await api.get(`${routeName}/${productId}/main-image`);
            
                if (response.data.succeeded===true) {
                  return response.data.data;
              }   
          } catch (error) {
            console.error("Error al obtener imágenes:", error);
              throw new Error("Error al obtener imágenes:");
          }

        }

        async deleteProductGallery(id: number): Promise<boolean> {
          try {
            const response = await api.delete<ApiResponse<any>>(`v1/gallery/${id}`);
            if (response.data.succeeded === true) {
              console.log(response);
              // Devuelve true si la actualización fue exitosa
              return true;
            } else {
              // Maneja el caso en el que la respuesta no tiene el formato esperado
              throw new Error("La respuesta no tiene el formato esperado");
            }
    
          
        } catch (error) {
          console.error("Error al eliminar imagen:", error);
            throw new Error("Error al eliminar imagen:");
          }
        }
    
        // async removeProduct(id: string): Promise<boolean> {
        //   try {
        //     // Realiza la petición DELETE utilizando axios
        //     const response = await axios.delete(`${baseURL}/${id}`);
      
        //     // Verifica si la respuesta contiene datos
        //     if (response.data.succeeded === true) {
        //       // Devuelve true si la eliminación fue exitosa
        //       return true;
        //     } else {
        //       // Maneja el caso en el que la respuesta no tiene el formato esperado
        //       throw new Error("La respuesta no tiene el formato esperado");
        //     }
        //   } catch (error) {
        //     // Maneja errores de solicitud
        //     console.error("Error al eliminar el producto:", error);
        //     throw new Error("Error al eliminar el producto");
        //   }
        // }

}